import ReBlankComponent from './re-blank-component'
Vue.component(ReBlankComponent.name, ReBlankComponent)

import ReToggleComponent from './re-toggle-component'
Vue.component(ReToggleComponent.name, ReToggleComponent)

import ReContentSections from './re-content-sections'
Vue.component(ReContentSections.name, ReContentSections)

import REToastAlert from './re-toast-alert'
Vue.component(REToastAlert.name, REToastAlert)

import RESimpleDropdown from './re-simple-dropdown'
Vue.component(RESimpleDropdown.name, RESimpleDropdown)

import ReGroupBox from './re-group-box'
Vue.component(ReGroupBox.name, ReGroupBox)

import ReTabContainer from './re-tab-container'
Vue.component(ReTabContainer.name, ReTabContainer)

import ReTabItem from './re-tab-item'
Vue.component(ReTabItem.name, ReTabItem)

import ReLoading from './re-loading'
Vue.component(ReLoading.name, ReLoading)

import ReBonusBox from './re-bonus-box'
Vue.component(ReBonusBox.name, ReBonusBox)

export default {
  //new components
  ReBlankComponent,
  ReToggleComponent,
  ReContentSections,
  REToastAlert,
  RESimpleDropdown,
  ReGroupBox,
  ReTabContainer,
  ReTabItem,
  ReLoading,
  ReBonusBox
}
